/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Loader } from '../';
import { Button, Dialog, Toolbar } from '../../components/prime';
import { IDataStorage, Translate } from '../../core';
import API from '../../services/api';
import Common from '../../services/common';
import { IResponse } from '../../services/model';
import { CardHelper, ICardEdit } from '../../services/operaciones/model/ICardEdit';
import Security from '../../services/seguridad';
import Alert from '../alerts';
import CardBotoneraComponent from './card-botonera.component';
import BoardCardFormContent from './card-content.component';
import BoardCardFormMenu from './card-menu.component';
import BoardCardFormQuickInfo from './card-quickinfo-component';
import styles from './index.module.scss';
import { AllSecciones, ICardSeccion } from './index.service';
import { fieldsToClass, fieldsToArray } from './helper';
import Question from '../question';

const CloseCard = (forceRefresh?: boolean) => (window as any).CloseCard(forceRefresh);

export type IProps = {
  storage: IDataStorage;

  tipo?: 'CO' | 'OP';
  id?: number;
}

function BoardCardForm({ storage,
  tipo, id,
} : IProps) {
  const t = Translate.get("components/board-card", storage.languaje);
  const [ questionReemitir, setQuestionReemitir ] = useState<undefined | 'ask' | 'procesing'>(undefined);
  // datos
  const [ cardData, setCardData ] = useState<ICardEdit|undefined|null>(undefined); // undefined = control invisible || null = cargando data || IOperacion = operacion cargada || ICotizacion = cotizacion cargada
  const [ idcliente, setIdcliente ] = useState<number | undefined | null>(undefined); // id de cliente actual (para verificar cuando cambia)
  const [ updates, setUpdates ] = useState<{ field: string, value: any }[]>([]);
  const [ loading, setLoading ] = useState<boolean>(false);
  const [ saving, setSaving ] = useState<boolean>(false);

  // secciones
  const [ secciones, setSecciones ] = useState<ICardSeccion[]>([]);
  const [ seccionSelected, setSeccionSelected ] = useState<ICardSeccion|undefined>(undefined);

  // menus
  const [ menuModo, setMenuModo ] = useState<'hidden' | 'collapsed' | 'normal'>('collapsed');
  const [ quickInfoModo, setQuickInfoModo ] = useState<'hidden' | 'collapsed' | 'normal'>('normal');

  // Maestros
  const [ vendedores, setVendedores ] = useMaestro(
    !cardData ? undefined : () => API.ClientesController().Cliente().vendedores({ idCliente: cardData?.cliente.id, includeNinguno: true, includeId: cardData?.operacion?.idvendedor ?? cardData?.cotizacion?.idvendedor }),
      (res) => Common.array.ComboItem(t, res??[])
  );
  const [ clientes ] = useMaestro(() => API.entity().cliente().all(), (res) => (res??[]).sort((a,b) => (a?.nombre??'') > (b?.nombre??'') ? 1 : -1));
  const [ paises ] = useMaestro(() => API.entity().pais().all(), (res) => (res??[]).sort((a,b) => (a?.nombre??'') > (b?.nombre??'') ? 1 : -1));
  const [ regiones ] = useMaestro(() => API.entity().region().all(), (res) => (res??[]).sort((a,b) => (a?.nombre??'') > (b?.nombre??'') ? 1 : -1));
  const [ monedas ] = useMaestro(() => API.CobranzaController().Moneda().combo({}), (res) => Common.array.ComboItem(t, res ?? []));
  const [ mediospago ] = useMaestro(() => API.CobranzaController().MedioPago().find({}), (res) => (res??[]).sort((a,b) => (a?.nombre??'') > (b?.nombre??'') ? 1 : -1));
  const [ submediospago ] = useMaestro(() => API.CobranzaController().MedioPago().submediopagos.all({}), (res) => (res??[]).sort((a,b) => (a?.nombre??'') > (b?.nombre??'') ? 1 : -1));
  const [ usuarios ] = useMaestro(() => API.SeguridadController().Usuario().find({}), (res) => (res??[]).sort((a,b) => `${a.nombre} ${a.apellido}` > `${b.nombre} ${b.apellido}` ? 1 : -1));

  // control de resize
  useEffect(() => {
    new ResizeObserver(() => {
      if (window.innerWidth > 630) return setMenuModo('collapsed');
      if (window.innerWidth < 630) return setMenuModo('hidden');
    }).observe($("body")[0]);
  }, []);

  // captura de cambio de tipo/id
  useEffect(() => {
    if (!Security.HasPermiso(83)) return;
    setCardData(null)
    setUpdates([]);
  }, [tipo, id]);

  // ocurre cuando se carga los datos de la tarjeta o se actualizan los datos
  useEffect(() => {
    if (cardData === null) {  // carga de datos por parámetros
      setCardData(undefined);
      if (!!tipo && !!id) {
        API.entity().card().get({ tipo, id }).then(res => {
          if (!res.success || !res.data) return Alert.reponse(res);
          let _data : any = res.data;
          if (window.app_usems) {
            _data = {
              cotizador: fieldsToClass(res.data, 'cotizador'),
              cliente: fieldsToClass(res.data, 'cliente'),
              marca: fieldsToClass(res.data, 'marca'),
              cotizacion: fieldsToClass(res.data, 'cotizacion'),
              calcpedido: fieldsToClass(res.data, 'calcpedido'),
              cotizacionmensajes: fieldsToArray(res.data, 'cotizacionmensajes'),
              operacion: fieldsToClass(res.data, 'operacion'),
              operacioncontactos: fieldsToArray(res.data, 'operacioncontacto'),
              operacionfacturacion: fieldsToClass(res.data, 'operacionfacturacion'),
              operacionpago: fieldsToClass(res.data, 'operacionpago'),
              operacionproducto: fieldsToClass(res.data, 'operacionproducto'),
              operacionpasajeros: fieldsToArray(res.data, 'operacionpasajeros'),
              operacionupgrades: fieldsToArray(res.data, 'operacionupgrades'),
              operacionvouchers: fieldsToArray(res.data, 'vouchers'),
              operacionadjuntos: fieldsToArray(res.data, 'operacionadjuntos'),
              operacionvoucheraudit: fieldsToArray(res.data, 'operacionvoucheraudit'),
              operacionestados: fieldsToArray(res.data, 'operacionestados'),
              operacionproductorecotizacion: fieldsToArray(res.data, 'operacionproductorecotizacion'),
            };

            if (_data.operacionfacturacion?.idfacturaarchivo) _data.operacionfacturacion.facturaArchivoDTO = { 
              id: _data.operacionfacturacion?.idfacturaarchivo,
              nombre: _data.operacionfacturacion?.facturaarchivo_nombre,
              url: _data.operacionfacturacion?.facturaarchivo_url,
            };
            if (_data.operacionfacturacion?.idliquidacionarchivo) _data.operacionfacturacion.liquidacionArchivoDTO = { 
              id: _data.operacionfacturacion?.idliquidacionarchivo,
              nombre: _data.operacionfacturacion?.liquidacionarchivo_nombre,
              url: _data.operacionfacturacion?.liquidacionarchivo_url,
            };
            if (_data.operacionfacturacion?.idfacturacomisionarchivo) _data.operacionfacturacion.facturaComisionArchivoDTO = { 
              id: _data.operacionfacturacion?.idfacturacomisionarchivo,
              nombre: _data.operacionfacturacion?.facturacomisionarchivo_nombre,
              url: _data.operacionfacturacion?.facturacomisionarchivo_url,
            };
            if (_data.operacionfacturacion?.idconciliadofacturaarchivo) _data.operacionfacturacion.conciliadoFacturaArchivoDTO = { 
              id: _data.operacionfacturacion?.idconciliadofacturaarchivo,
              nombre: _data.operacionfacturacion?.conciliadofacturaarchivo_nombre,
              url: _data.operacionfacturacion?.conciliadofacturaarchivo_url,
            };
            if (_data.operacionfacturacion?.idnotacreditoarchivo) _data.operacionfacturacion.notacreditoArchivoDTO = { 
              id: _data.operacionfacturacion?.idnotacreditoarchivo,
              nombre: _data.operacionfacturacion?.notacreditoarchivo_nombre,
              url: _data.operacionfacturacion?.notacreditoarchivo_url,
            };
          }
          setCardData(_data);
        }).catch(err => Alert.error(t("@Id#ErrorInesperado"), `${err}`))
      }
    } else if (!!cardData) {  // actualización de datos
      setSecciones(AllSecciones.filter(s => !s.hide(cardData)));
      if (idcliente !== cardData?.cliente?.id && !!cardData?.cliente?.id) setVendedores(null);  // actualizo los vendedores si es que hubo un cambio de cliente
      setIdcliente(cardData?.cliente?.id);
    }
  }, [cardData]);


  const onUpdateFields = (toupdate: { field: string, value: any }[]) => {
    const upds : { field: string, value: any }[] = [];
    toupdate.forEach(upd => {
      const val = Common.object.getCascadePropValue(cardData, upd.field);
      if (val !== upd.value) {
        upds.push(upd);
        Common.object.setCascadePropValue(cardData, upd.field, upd.value, () => ({}));
      }
    });
    if (upds.length > 0) {
      const toremove = upds.map(u => u.field);
      const removed = updates.filter(p => !toremove.includes(p.field));
      setUpdates([ ...removed, ...upds ]);
      const newData = { ...{ random: Math.random() }, ...cardData };
      setCardData(newData as ICardEdit);
    }
  };

  const OnSave = () => {
    if (!updates || updates.length < 1 || !tipo || !id) return;
    setLoading(true);
    const keyvalues = updates.map(x => ({ key: x.field, value: JSON.stringify(x.value) }));

    keyvalues.forEach(kv => {
      // if is date
      if (/^"\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,7})Z"$/g.test(kv.value)) {
        kv.value = `${kv.value.substring(0, 11)}T00:00:00Z"`
      }
    });


    API.OperacionesController().Card().update({ tipo, id, updates: keyvalues }).then(res => {
      if (!res.success) return Alert.reponse(res);
      setUpdates([]);

      if (CardHelper.mustAskForReemitir(cardData, keyvalues.map(k => k.key)))
        setQuestionReemitir('ask');
    }).catch((err: unknown) => Alert.error(`${err}`.substring(0, 50), `${err}`))
    .finally(() => setLoading(false));
  }


  const menuWidth = menuModo === 'hidden' ? 0 : ( menuModo === 'collapsed' ? 30 : 150 );
  const quickInfoWidth = quickInfoModo === 'hidden' ? 0 : ( quickInfoModo === 'collapsed' ? 30 : (menuModo === 'hidden' ? 300 : 480) );

  const titleText = !!(cardData?.operacion?.codigo ?? cardData?.operacion?.numero)
    ? `O${cardData?.operacion?.codigo ?? cardData?.operacion?.numero}`
    : `C${cardData?.cotizacion?.codigo ?? cardData?.cotizacion?.id}`;

  return <>
    <Dialog
      visible={!!id && !!tipo && Security.HasPermiso(83)} onHide={() => CloseCard()}
      className={styles["modal"]}
      header={<>
        {titleText}
        {<i className={`far fa-copy ${styles['btn-copy']}`} onClick={() => navigator.clipboard.writeText(titleText)}></i>}
      </>}
      footer={<Loader loading={!cardData || loading || saving} height="100%">
        <Toolbar 
          left={<CardBotoneraComponent t={t} cardData={cardData} existsUpdates={updates.length > 0} mediospago={mediospago} setSaving={(v) => setSaving(v)} />}
          right={<>
            <Button label={t("Botonera.Guardar")} icon="pi pi-save" className="p-button-success" disabled={(updates?.filter(p => p.field !== 'random').length ?? 0) < 1} onClick={OnSave} />
          </>} 
        />
      </Loader>}
    >
      <Loader loading={!cardData || loading || saving} height="100%">
        <div className={styles["boardcard-container"]}>
          {menuModo !== 'hidden' &&
            <div className={styles["boardcard-container-menu"]} style={{ width: menuWidth, minWidth: menuWidth, maxWidth: menuWidth }}>
              <BoardCardFormMenu t={t} modo={menuModo} onChangeModo={(m) => setMenuModo(m)} width={menuWidth} secciones={secciones} selected={seccionSelected} onSelectMenu={m => setSeccionSelected(m)} />
            </div>
          }

          <div className={styles["boardcard-container-content"]}>
            <BoardCardFormContent 
              t={t} data={cardData} 
              secciones={secciones} selected={seccionSelected} 
              paises={paises} regiones={regiones} monedas={monedas} submediospago={submediospago} usuarios={usuarios}
              onUpdateFields={onUpdateFields}
            />
          </div>
          <div className={styles["boardcard-container-quickinfo"]} style={{ width: quickInfoWidth, minWidth: quickInfoWidth, maxWidth: quickInfoWidth }}>
            <BoardCardFormQuickInfo t={t} 
              data={cardData} 
              modo={quickInfoModo} onChangeModo={(m) => setQuickInfoModo(m)} width={quickInfoWidth}  
              clientes={clientes} vendedores={vendedores} usuarios={usuarios}
              onUpdateFields={onUpdateFields}
            />
          </div>
        </div>
      </Loader>
    </Dialog>
    
    <Question
      text={t("Question.ReEmitirVoucher.Text")}
      title={t("Question.ReEmitirVoucher.Title")}
      ok_text={t("Question.ReEmitirVoucher.Ok")}
      cancel_text={t("Question.ReEmitirVoucher.Cancel")}
      visible={!!questionReemitir}
      working={questionReemitir === 'procesing'}
      ok={() => {
        setQuestionReemitir('procesing');
        CardHelper.reemitirIfAllow(cardData, ['force']).then(res => {
          if (!res.success) {
            setQuestionReemitir(undefined);
            return Alert.reponse(res);
          }
          setQuestionReemitir(undefined);
          CloseCard(true);
        }).catch(ex => Alert.exception(t, ex))
      }}
      onClose={() => setQuestionReemitir(undefined)}
    />
  </>;
}

export default connect((s:any) => ({ storage:s.main }))(BoardCardForm);


export const useMaestro = <T extends unknown, D extends unknown>(
  api?: () => Promise<IResponse<D>>,
  transformData?: (arrived: D | undefined) => T,
) : [ T | null | undefined, (value: T | null | undefined) => void ] => {  
  const [ state, setState ] = useState<T|undefined|null>(undefined);
  useEffect(() => {
    setState(null)
  }, []);
  useEffect(() => {
    LoadInfo<T | null | undefined, D>(state, setState, api, transformData)
  }, [state]);
  return [ state, setState ];
}

/** Carga información desde el API */
const LoadInfo = <T extends unknown, D extends unknown>(
  state: T | null | undefined, 
  setState: (newstate: T | null | undefined) => void,
  api?: () => Promise<IResponse<D>>,
  transformData?: (arrived: D | undefined) => T,
) : void => {  
  if (state === null) {
    setState(undefined);
    if (!!api) {
      api().then(res => {
        Alert.reponse(res);
        const newState = !!transformData ? transformData(res.data) : res.data as T;
        setState(newState);
      }).catch((err: unknown) => Alert.error(`${err}`.substring(0, 50), `${err}`))
    }
  }
}